<template>
  <div :class="{ rtl: isRTL }">
    <base-header v-if="!landingState && !hideHeaderAndFooter" />
    <b-card v-if="loadingSkeleton" class="skeletonArea">
      <b-skeleton animation="wave" width="85%" />
      <b-skeleton animation="wave" width="53%" />
      <b-skeleton animation="wave" width="70%" />
      <!--  -->
      <b-skeleton animation="wave" width="85%" />
      <b-skeleton animation="wave" width="53%" />
      <b-skeleton animation="wave" width="70%" />
      <!--  -->
      <b-skeleton animation="wave" width="85%" />
      <b-skeleton animation="wave" width="53%" />
      <b-skeleton animation="wave" width="70%" />
      <!--  -->
      <b-skeleton animation="wave" width="85%" />
      <b-skeleton animation="wave" width="53%" />
      <b-skeleton animation="wave" width="70%" />
    </b-card>
    <router-view v-show="!loadingSkeleton" @hook:mounted="handleRouteLoaded" />
    <base-footer v-if="!landingState && !hideHeaderAndFooter" />
    <base-alert />
  </div>
</template>

<script>
import BaseFooter from "./components/layout/BaseFooter.vue";
import BaseHeader from "./components/layout/BaseHeader.vue";
import logoutMixin from "./mixins/logoutMixin";
import serviceResponseHelper from "./mixins/serviceResponseHelper";
import BaseAlert from "./components/element/BaseAlert";
import { SkeletonPlugin, CardPlugin } from "bootstrap-vue";
import Vue from "vue";

Vue.use(CardPlugin);
Vue.use(SkeletonPlugin);
export default {
  name: "App",
  components: { BaseAlert, BaseHeader, BaseFooter },
  mixins: [logoutMixin, serviceResponseHelper],
  data() {
    return {
      hideHeaderAndFooter: false,
      loadingSkeleton: true,
    };
  },
  computed: {
    isRTL() {
      return this.$i18n.locale === "fa";
    },
    landingState: {
      get() {
        return this.$store.getters.getLandingState;
      },
    },
    lastActionDate: {
      get() {
        return this.$store.getters.getActionDate;
      },
      set(val) {
        this.$store.commit("setLastActionDate", val);
      },
    },
    parametersSalesChannelBased: {
      get() {
        return this.$store.getters.getParametersSalesChannelBased;
      },
    },
    loggedIn: {
      get() {
        return this.$store.getters.getLoggedIn;
      },
    },
    user: {
      get() {
        return this.$store.getters.getUser;
      },
    },
    customerInformation: {
      get() {
        return this.$store.getters.getCustomerInformation;
      },
      set(val) {
        this.$store.commit("setCustomerInformation", val);
      },
    },
  },
  watch: {
    isRTL(newValue) {
      document.documentElement.dir = newValue ? "rtl" : "ltr";
    },
    $route() {
      this.loadingSkeleton = true;
    },
  },
  created() {
    if (this.$route.name !== "landing") {
      this.$store.commit("setLandingState", false);
    }
    this.hideHeaderAndFooter = this.$route.meta.hideHeaderAndFooter;
    document.documentElement.dir = this.isRTL ? "rtl" : "ltr";
  },
  mounted() {
    this.iosCatchAndFocusClose();
    this.fetchParametersSalesChannelBased();
    if (!this.loggedIn && (!this.customerInformation.id || !this.user.userId)) {
      if (
        window.location.href === window.location.origin + "/kullanici-bilgisi" ||
        window.location.href === window.location.origin + "/biletlerim-rezervasyonlarim" ||
        window.location.href === window.location.origin + "/biletlerim-rezervasyonlarim" ||
        window.location.href === window.location.origin + "/acik-biletlerim-ve-iade-kuponlarim" ||
        window.location.href === window.location.origin + "/sifre-guncelleme" ||
        window.location.href === window.location.origin + "/abonmanliklarim" ||
        window.location.href === window.location.origin + "/kayitli-kisilerim" ||
        window.location.href === window.location.origin + "/kayitli-fatura-bilgilerim" ||
        window.location.href === window.location.origin + "/alarmlarim" ||
        window.location.href === window.location.origin + "/bagli-cihazlar"
      ) {
        this.callAlert(4, this.$t("user-information-login"), "danger", this.$t("failed-transaction-title"));
        this.$router.push("/");
      }
    }
    $(document).on("focusin", (event) => {
      if ($(event.target).hasClass("vld-overlay")) {
        event.stopImmediatePropagation();
        return false; // jQuery için özel engelleme
      }
    });
  },
  updated() {
    if (this.lastActionDate === null) {
      this.$store.commit("setLastActionDate", new Date().getTime());
    }
    const currentDate = new Date().getTime();
    const halfHourLateDate = this.addMinutes(this.lastActionDate, 30);
    // console.log("updated...")
    if (currentDate > halfHourLateDate) {
      this.callAlert(4, this.$t("session-ended"), "warning", this.$t("log-in-again"));
      this.logout();
    }
    this.$store.commit("setLastActionDate", new Date().getTime());
  },
  methods: {
    iosCatchAndFocusClose() {
      const addMaximumScaleToMetaViewport = () => {
        const el = document.querySelector("meta[name=viewport]");
        if (el !== null) {
          let content = el.getAttribute("content");
          let re = /maximum\-scale=[0-9\.]+/g;

          if (re.test(content)) {
            content = content.replace(re, "maximum-scale=1.0");
          } else {
            content = [content, "maximum-scale=1.0"].join(", ");
          }
          el.setAttribute("content", content);
        }
      };

      const disableIosTextFieldZoom = addMaximumScaleToMetaViewport;

      const checkIsIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

      if (checkIsIOS()) {
        disableIosTextFieldZoom();
      }
    },
    async fetchParametersSalesChannelBased() {
      if (this.parametersSalesChannelBased === null) {
        const request = "INTERNET";
        await this.$store.dispatch("parametersSalesChannelBased", request).then((response) => {
          if (response.data.code !== 0) {
            this.$store.commit("setParametersSalesChannelBased", response.data.maxPax);
          } else {
            this.$store.commit("setParametersSalesChannelBased", null);
          }
        });
        // .catch(() => {
        //   this.$store.commit("setParametersSalesChannelBased", 11);
        // })
      }
    },
    clearLocalStorage() {
      const CURRENT_VERSION = JSON.stringify(this.$store.getters.getAppVersion);
      const storedVersion = localStorage.getItem("appVersion");
      const enrollees = JSON.parse(JSON.stringify(localStorage.getItem("enrollees")));
      if (storedVersion !== CURRENT_VERSION) {
        localStorage.clear();
        localStorage.setItem("appVersion", CURRENT_VERSION);
        localStorage.setItem("enrollees", enrollees);
      }
    },
    handleRouteLoaded() {
      this.loadingSkeleton = false;
    },
  },
};
</script>

<style scoped>
.rtl {
  direction: rtl;
  text-align: right;
}

.rtl .dropdown-menu {
  text-align: right;
}

.rtl .form-check {
  padding-right: 1.25rem;
  padding-left: 0;
}

.rtl .form-check-input {
  margin-right: -1.25rem;
  margin-left: 0;
}

.rtl .invalid-feedback {
  text-align: right;
}

.rtl .input-group > .form-control:not(:last-child) {
  border-radius: 0 0.25rem 0.25rem 0;
}

.rtl .input-group > .input-group-append > .btn {
  border-radius: 0.25rem 0 0 0.25rem;
}

.rtl .mr-auto {
  margin-right: 0 !important;
  margin-left: auto !important;
}

.rtl .ml-auto {
  margin-left: 0 !important;
  margin-right: auto !important;
}

.rtl .text-left {
  text-align: right !important;
}

.rtl .text-right {
  text-align: left !important;
}
</style>
